import $ from 'jquery';
window.$ = window.jQuery = $;
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.timeout = 20000; //20 sec default timeout
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

import 'lazysizes';
require('jquery.uniform');
require('select2');
$('.select2').select2({
    minimumResultsForSearch: -1
});
$('.select2-plain').select2({
    minimumResultsForSearch: -1,
    theme: 'plain-select'
});

//require('flexslider');
//require('password-strength-meter');
//require('jquery-ui');
//require('jquery-ui/ui/widgets/sortable');
//require('jquery-ui/ui/widgets/datepicker');
//require('slick-carousel');